export enum ResendValues {
  MX = 'MX',
  paperMail = 'Paper/Mail',
}
